import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Main.scss';
import profile from '../assets/images/profile.jpg';
import FadeIn from './FadeIn'; 

function Main() {
  return (
    <div className="container">
      <div className="about-section">
        
        <div className="image-wrapper">
          <img src={profile} alt="Yash Mathur Profile" width="150" height="150"/>
        </div>

        <FadeIn className="content" delay={150} transitionDuration={800}>
          
          <div className="social_icons">
            <a href="mailto:mathury@purdue.edu" target="_blank" rel="noreferrer"><EmailIcon /></a>
            <a href="https://www.linkedin.com/in/mathur-yash/" target="_blank" rel="noreferrer" aria-label="Send email to Yash Mathur"><LinkedInIcon/></a>
          </div>
          
          <h1>Yash Mathur</h1>
          
          {/* Primary Professional Identity */}
          <p style={{ 
              fontSize: '1.8em', 
              fontWeight: '700', 
              marginBottom: '8px',
              letterSpacing: '-0.5px'
            }}>
            Controls & Simulation Engineer
          </p>
          
          {/* Secondary Context - Simplified */}
          <p style={{ 
              fontSize: '1.2em', 
              fontWeight: '400',
              marginBottom: '35px',
              opacity: 0.9 /* Slightly softer than the main title */
            }}>
            M.S. Candidate at Purdue University
          </p>
          
          {/* REMOVED: The "Bridging the gap" quote section to reduce text density */}
          
          <div className="mobile_social_icons">
            <a href="mailto:mathury@purdue.edu" target="_blank" rel="noreferrer"><EmailIcon /></a>
            <a href="https://www.linkedin.com/in/mathur-yash/" target="_blank" rel="noreferrer" aria-label="Visit Yash Mathur's LinkedIn Profile"><LinkedInIcon/></a>
          </div>

          <div className="resume-button-container">
             <a 
               href={process.env.PUBLIC_URL + '/resume.pdf'} 
               target="_blank" 
               rel="noreferrer"
               style={{
                 textDecoration: 'none',
                 display: 'inline-block',
                 padding: '10px 25px',
                 backgroundColor: '#5000ca', 
                 color: 'white',
                 fontWeight: 'bold',
                 borderRadius: '5px',
                 boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                 transition: 'transform 0.2s'
               }}
               onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
               onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
             >
               Download Resume
             </a>
          </div>

        </FadeIn>
      </div>
    </div>
  );
}

export default Main;